import React from 'react'
import {
  CloseButton,
  DetailPart,
  PhoneElement,
  PhonePart,
  PhoneScreen,
  PhoneSkeleton,
  QRCodeContainer,
  RedirectionItemsContainer,
  ScanQRText,
  ScreenBackground,
  StoresContainer,
  StyledText,
} from './AppExclusiveScreenStyles'
import { IconImage } from '../DailyPlay/DailyPlayStyles'
import { mediaURL } from 'src/consumer/services'
import { redirectToAppQR } from 'src/consumer/constants'

import { APP_CONSTANTS } from 'src/consumer/constants'
import logo_brand from 'src/assets/logo_brand.png'
import phone_skeleton from 'src/assets/phone_skeleton.png'
import app_interface from 'src/assets/app_interface.png'
import app_store from 'src/assets/app_store.png'
import play_store from 'src/assets/play_store.png'
import close_icon_purple from 'src/assets/close_icon_purple.png'

export default function AppExclusiveScreen(props) {
  const { closeModal } = props
  return (
    <ScreenBackground>
      <PhonePart>
        <IconImage 
          src={APP_CONSTANTS.APP_LOGO_LINK} 
          w={78} 
          h={70} 
          style={{ borderRadius: '7px' }} 
          onError={(e) => {
            e.target.src = logo_brand
          }}
        />
        <PhoneElement>
          <PhoneSkeleton src={phone_skeleton} />
          <PhoneScreen src={app_interface} />
        </PhoneElement>
      </PhonePart>

      <DetailPart>
        <StyledText heading>The item you are viewing is app exculsive.</StyledText>

        <StyledText>
          This item can only be accessed through our IOS or Android application. If you already have
          our application then scanning the qr code below will redirect you to the application. If
          you do not, QR code will take you to the store to install it.
        </StyledText>

        <RedirectionItemsContainer>
          <StoresContainer>
            <IconImage
              style={{ cursor: 'pointer' }}
              src={app_store}
              w={175}
              onClick={() =>
                (window.location.href =
                  'https://apps.apple.com/in/app/aumhum-meditate-breathe/id1474055225')
              }
            />
            <IconImage
              style={{ cursor: 'pointer' }}
              src={play_store}
              w={175}
              onClick={() =>
                (window.location.href =
                  'https://play.google.com/store/apps/details?id=com.aumhum.aumhum&pli=1')
              }
            />
            <ScanQRText>Scan this QR code to access the course</ScanQRText>
          </StoresContainer>
          <QRCodeContainer>
            <IconImage src={`${mediaURL}${redirectToAppQR}`} w={170} h={170} />
          </QRCodeContainer>
        </RedirectionItemsContainer>
      </DetailPart>

      <CloseButton src={close_icon_purple} onClick={closeModal} />
    </ScreenBackground>
  )
}
